import styled from '@emotion/styled';

export default styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #00000019;

  h2 {
    font-size: 18px;
    font-weight: 500;
  }
`;
